import { Check, AlertTriangle, Loader2 } from "lucide-react";
import { STATI, STATO_STYLE } from "../lib/constants";

export const PipelineStepper = ({ stato, tipo }) => {
  const steps = tipo === "testo" ? STATI.filter((s) => s !== "IN_TRASCRIZIONE") : STATI;
  const isError = stato === "ERRORE" || stato === "NON_PERTINENTE";
  const errColor = stato === "NON_PERTINENTE" ? STATO_STYLE.NON_PERTINENTE : STATO_STYLE.ERRORE;
  const currentIdx = steps.indexOf(stato);

  return (
    <div data-testid="pipeline-stepper" className="flex items-center gap-2 overflow-x-auto py-2">
      {steps.map((s, i) => {
        const done = !isError && currentIdx > i;
        const active = !isError && currentIdx === i && s !== "INDICIZZATO";
        const finished = !isError && s === "INDICIZZATO" && stato === "INDICIZZATO";
        const style = STATO_STYLE[s];
        const color = done || finished ? "#34D399" : active ? style.text : isError ? errColor.text : "#4B5563";
        return (
          <div key={s} className="flex items-center gap-2 shrink-0">
            <div className="flex items-center gap-2">
              <div
                className="flex h-7 w-7 items-center justify-center rounded-full border-2 transition-colors duration-300"
                style={{ borderColor: color, background: done || finished ? "rgba(16,185,129,0.15)" : "transparent" }}
              >
                {done || finished ? (
                  <Check className="h-3.5 w-3.5" style={{ color }} />
                ) : active ? (
                  <Loader2 className="h-3.5 w-3.5 spin-slow" style={{ color }} />
                ) : isError && i === (currentIdx === -1 ? steps.length - 1 : currentIdx) ? (
                  <AlertTriangle className="h-3.5 w-3.5" style={{ color }} />
                ) : (
                  <span className="h-1.5 w-1.5 rounded-full" style={{ background: color }} />
                )}
              </div>
              <span className="text-xs font-mono font-medium" style={{ color }}>
                {s}
              </span>
            </div>
            {i < steps.length - 1 && <div className="h-px w-8 sm:w-14" style={{ background: done ? "#34D399" : "#374151" }} />}
          </div>
        );
      })}
      {isError && (
        <span data-testid="stepper-error-label" className="ml-2 rounded-full px-2.5 py-1 text-xs font-mono font-semibold" style={{ background: errColor.bg, color: errColor.text }}>
          {stato}
        </span>
      )}
    </div>
  );
};
